module.exports = __webpack_public_path__ + "static/media/U1-T2-2-2a.6bf0c427.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-2-2a.svg
// module id = 540
// module chunks = 0